module.exports = __webpack_public_path__ + "img/IMG_2399_T_L_Wood_MockedUp.70bf6041.jpg";